import { request } from "./requests";

const SERVICE = "/structureCategory/api/v1";

export const findAllStructureCategories = () => {
  return request.get(SERVICE + "/findAll");
};

export const findStructureCategoriesWithTotalItem = () => {
  return request.get(SERVICE + "/findAllWithTotalItem");
};
